export const name = '$gzAppNav';

export const EMPHASIS_BACKGROUND = "#EEEEEE";
export const DEFAULT_BACKGROUND = "#FFFFFF";

/**
 * @ngdoc service
 * @name gazelle.components.appNav.service:$gzAppNav
 *
 * @description
 * The $gzAppNav service allows the application to specify the background color to use below the app nav menu.
 *
 *
 * @usage
 * ```js
 * // In 'my-apps' controller.activate method:
 * $gzAppNav.setEmphasisBackground('hp-emphasis-background'});
 * ```
 */
export default function $gzAppNav($log, $rootScope) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  let bgColor = DEFAULT_BACKGROUND;
  let transColor = DEFAULT_BACKGROUND;

  let service = {
    setEmphasisBackground,
    setBackgroundColor,
    bgColor: getBackgroundColor
  };

  activate();
  return service;

  function activate() {
    $rootScope.$on('$stateChangeStart', () => {
      transColor = DEFAULT_BACKGROUND;
    });
    $rootScope.$on('$stateChangeSuccess', () => {
      bgColor = transColor;
    });
  }

  /**
   * @ngdoc function
   * @name setEmphasisBackground
   * @methodOf gazelle.components.appNav.service:$gzAppNav
   * @description Sets the background color for the nav bar during ui-router transition to `$hp-emphasis-background` (`#EEEEEE`)
   */
  function setEmphasisBackground() {
    $log.debug('gzAppNav setEmphasisBackground called');
    transColor = EMPHASIS_BACKGROUND;
  }

  /**
   * @ngdoc function
   * @name setBackgroundColor
   * @methodOf gazelle.components.appNav.service:$gzAppNav
   * @description Sets the background color for the nav bar during ui-router transition
   * @param {string} color - hex color definition used in background-color style attribute (e.g. "#EEEEEE")
   */
  function setBackgroundColor(color) {
    transColor = color;
  }

  function getBackgroundColor() {
    return bgColor;
  }
}
